//import React, { useContext } from "react";
import axios from "axios";
import { useContext,useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
//import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import { AuthContext } from "../helpers/AuthContext";
//import { PostContext } from "../helpers/PostContext";
//import { BasicInfoContext } from "../helpers/BasicInfoContext";

function Home() {
  const [listOfPosts, setListOfPosts] = useState([]);
  const [likedPosts, setLikedPosts] = useState([]);
  const { authState } = useContext(AuthContext);
 // const { setPostState } = useContext(PostContext);
 // const { setBasicInfoState } = useContext(BasicInfoContext);
  let history = useHistory();

  useEffect(() => {
   
    if (!localStorage.getItem("accessToken")) {
      history.push("/login");
    } else {
    const controller = new AbortController();
    const fetchPosts = async () => {
      try {
       axios.get("https://api.inloop.live/posts", {
          headers: { accessToken: localStorage.getItem("accessToken") },
        })
        .then((response) => {
          setListOfPosts(response.data.listOfPosts);
          setLikedPosts(
            response.data.likedPosts.map((like) => {
              return like.PostId;
            })
          );
        });
    } catch (err){
      if (axios.isCancel(err)) return;
      console.log(err);
    }

  }
  fetchPosts();
  return () => controller.abort();
  };

  }, [history]);

  const likeAPost = (postId) => {
    axios
      .post(
        "https://api.inloop.live/likes",
        { PostId: postId },
        { headers: { accessToken: localStorage.getItem("accessToken") } }
      )
      .then((response) => {
        setListOfPosts(
          listOfPosts.map((post) => {
            if (post.id === postId) {
              if (response.data.liked) {
                return { ...post, Likes: [...post.Likes, 0] };
              } else {
                const likesArray = post.Likes;
                likesArray.pop();
                return { ...post, Likes: likesArray };
              }
            } else {
              return post;
            }
          })
        );

        if (likedPosts.includes(postId)) {
          setLikedPosts(
            likedPosts.filter((id) => {
              return id !== postId;
            })
          );
        } else {
          setLikedPosts([...likedPosts, postId]);
        }
      });
  };

  return (
    <div>
      <div id="top"></div>
      <h1>Hello,{authState.username}, this is homepage</h1>
      <h2>View past or active posts for sponsorships</h2>
      {listOfPosts.map((value, key) => {
        return (
          <div key={key} className="post">
            <div className="title"> {value.title} </div>
            <div
              className="body"
              onClick={() => {
                history.push("/post/"+String(value.id));
              }}
            >
              {value.postText}
            </div>
            <div className="footer">
              <div className="username">
                <Link to={"/profile/"+String(value.UserId)}>{value.username} </Link>
              </div>
              <div className="buttons">
                
                <button id={String(value.id)+"s"} onClick={() => 
                  { likeAPost(value.id); 
                    var sText = document.getElementById(value.id);
                    var sBox = document.getElementById(value.id+"s");
                    if ((sText===undefined) && (sBox===undefined)){
                      alert("Refresh the page!");
                    }
                    else if (sText.innerText==="Apply!"){
                      sText.innerText="Cancel?";
                      sBox.style.backgroundColor='red';
                    }
                    else{
                      sText.innerText="Apply!";
                      sBox.style.backgroundColor='green';
                      alert("Consider reapplying!");
                    }
                  }} 
                  className={likedPosts.includes(value.id) ? "unlikeBttn" : "likeBttn" }>
                    <b id={String(value.id)}>Apply!</b>
                  
                  
                  
                   
                 
                  
                    
                 
                
               </button><label> {value.Likes.length}<Link to="https://www.paypal.com/ncp/payment/YC5NSR8YE9Z96">, Pay</Link></label>
                
              </div>
            </div>
          </div>
        );
      })}
     <b> Hello this is the end! Maybe refresh...</b>
    <a href="#top"><button>Go to top</button></a> 
    </div>
  );
}

export default Home;
